import InvitationLinksApp from "./InvitationLinksApp.vue";
import { vueApp } from "../Common/vueApp";

export default vueApp(InvitationLinksApp);
